<template>
  <q-card
    v-if="
      $store.state.packages.packageStatus?.current_package?.stocks?.length >
        0 && $store.state.core.allStocks?.length > 0
    "
    flat
    bordered
    class="row q-my-sm q-py-xs"
  >
    <div
      v-if="filterList.includes('stocks')"
      class="col-4 col-xs-6 col-sm-4 q-pa-xs"
    >
      <q-select
        ref="searchbar"
        v-model.lazy="searchedSymbol"
        :options="optionData"
        option-label="symbol"
        emit-value="symbol"
        label="Search stock"
        outline
        dense
        behavior="box"
        clearable
        use-input
        :menu-absolute="true"
        @filter="filterSymbol"
        class="q-mx-sm ellipsis"
        :popup-content-style="{ 'max-height': '50vw' }"
      >
        <template v-slot:option="scope">
          <q-item v-bind="scope.itemProps">
            <q-item-section avatar>
              <q-item-label class="text-bol">{{
                scope.opt.symbol
              }}</q-item-label>
            </q-item-section>
          </q-item>
        </template>
        <template v-slot:no-option>
          <q-item>
            <q-item-section> No data available </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div
      v-if="filterList.includes('mySignals') && !isMySignal"
      class="col-4 col-xs-6 col-sm-4 q-pa-md"
    >
      <q-checkbox
        dense
        class="q-pr-sm ellipsis"
        v-model="mySignals"
        color="blue-5"
        keep-color
        label="My Signals"
      >
        <q-tooltip class="bg-primary">My Signals Only</q-tooltip>
      </q-checkbox>
    </div>
    <div
      v-if="filterList.includes('volume')"
      class="col-4 col-xs-6 col-sm-4 q-pa-md"
    >
      <q-checkbox
        dense
        v-model="volumeGreaterThenAvgVol"
        color="blue-5"
        keep-color
        label="Volume"
        class="ellipsis"
      >
        <q-tooltip class="bg-primary"
          >Volume greater then average volume</q-tooltip
        >
      </q-checkbox>
    </div>
    <div
      v-if="filterList.includes('sectors')"
      class="col-4 col-xs-6 col-sm-4 q-pa-xs"
    >
      <q-select
        outline
        v-model="selectedSector"
        :options="optionSectors"
        dense
        label="Choose sector"
        single
        input-debounce="0"
        option-label="name"
        option-value="symbol"
        class="q-mx-sm ellipsis"
        :menu-absolute="true"
      />
    </div>
    <div
      v-if="filterList.includes('riskReward')"
      class="col-4 col-xs-6 col-sm-4 q-pa-xs"
    >
      <q-select
        outline
        v-model="riskReward"
        :options="['All', 'Less than 1', 'Greater than 1']"
        dense
        label="Risk Reward"
        single
        class="q-mx-sm"
        :menu-absolute="true"
      />
    </div>
    <div
      v-if="filterList.includes('validInvalid')"
      class="col-4 col-xs-6 col-sm-4 q-pa-xs"
    >
      <q-select
        outline
        v-model="isValid"
        :options="['All', 'VALID', 'INVALID', 'SIGNAL']"
        dense
        label="Valid/Invalid"
        single
        class="q-mx-sm"
        :menu-absolute="true"
      />
    </div>
  </q-card>
</template>
<script>
import { ref, computed, watch, onMounted } from "vue";
import useUtils from "src/use/utils";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
export default {
  name: "searchSignals",
  props: {
    isMySignal: {
      type: Boolean,
      default: false,
    },
    isStockProfile: {
      type: Boolean,
      default: false,
    },
    stockSymbol: {
      type: String,
      default: null,
    },
    buttonBuyOrSell: {
      type: String,
      default() {
        "buy";
      },
    },
    buyData: { type: Array },
    sellData: { type: Array },
    filterList: { type: Array, default: () => [] },
    indicatorsSymbols: {
      type: Array,
      default() {
        return [];
      },
    },
    isStatusVALID: { type: Boolean, default: false },
    indicatorsDate: { type: String },
    indicatorsValue: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ["filteredData"],

  setup(props, context) {
    const $route = useRoute();
    const { utilsOptionSectors } = useUtils();
    const searchedSymbol = ref(null);

    const riskReward = ref("All");
    const isValid = ref("All");
    const optionSectors = ref(utilsOptionSectors());
    const selectedSector = ref(optionSectors.value[0]);
    const $store = useStore();
    const optionData = ref([]);

    const filterSymbol = (searchText, update) => {
      if (searchText === "") {
        update(() => {
          optionData.value = finalComputedData.value;
        });
        return;
      }
      update(() => {
        const needle = searchText.toLowerCase();
        optionData.value = finalComputedData.value.filter((s) => {
          return s.symbol.toLowerCase().indexOf(needle) > -1;
        });
      });
    };

    let mySignals = ref(props.isMySignal ? true : false);
    let volumeGreaterThenAvgVol = ref(false);

    const computedBuyOrSellData = computed(() => {
      if (props.buyData.length > 0 || props.sellData.length > 0) {
        const data =
          props.buttonBuyOrSell == "buy" ? props.buyData : props.sellData;

        const result = data.filter((i) => {
          let averageVolume = true;
          let onlyMySignals = true;
          let sectorWise = true;

          if (
            mySignals.value &&
            $store.state.packages.packageStatus?.current_package.stocks.length >
              0
          )
            onlyMySignals =
              $store.state.packages.packageStatus?.current_package.stocks?.indexOf(
                i?.symbol
              ) != -1;

          if (volumeGreaterThenAvgVol.value)
            averageVolume = i?.volume > i?.avg_vol;

          if (
            selectedSector.value?.id != 0 &&
            $store.state.core.allStocks?.length > 0
          ) {
            sectorWise = $store.state.core.allStocks
              .filter((stock) => stock.sector == selectedSector.value.id)
              .map((item) => item.symbol)
              .includes(i?.symbol);
          }

          return averageVolume && onlyMySignals && sectorWise;
        });
        return result;
      } else return [];
    });

    const finalComputedData = computed(() => {
      const isAllRiskReward = riskReward.value === "All";
      const isGreaterRiskReward = riskReward.value === "Greater than 1";
      const isLessRiskReward = riskReward.value === "Less than 1";
      const isStatusAll = isValid.value === "All";
      const isStatusVALID = isValid.value === "VALID";
      const isStatusSIGNAL = isValid.value === "SIGNAL";
      const isStatusINVALID = isValid.value === "INVALID";

      const finalData = props.isStockProfile
        ? computedBuyOrSellData.value.filter(
            (i) => i.symbol === props.stockSymbol
          )
        : computedBuyOrSellData.value;

      return finalData.filter((item) => {
        const isSymbolMatch =
          !searchedSymbol.value || item.symbol === searchedSymbol.value.symbol;

        const isStatusMatch =
          isStatusAll ||
          (isStatusVALID && (item.status === "VALID" || !item.status)) ||
          (isStatusSIGNAL && (item.status === "SIGNAL" || !item.status)) ||
          (isStatusINVALID && (item.status === "INVALID" || !item.status));

        const isRiskRewardMatch =
          isAllRiskReward ||
          (isGreaterRiskReward && item.risk_reward > 1) ||
          (isLessRiskReward && item.risk_reward < 1);

        const isIndicatorsMatch =
          props.indicatorsValue.length === 0 ||
          (item.date === props.indicatorsDate &&
            props.indicatorsSymbols.includes(item.symbol));

        return (
          isSymbolMatch &&
          isStatusMatch &&
          isRiskRewardMatch &&
          isIndicatorsMatch
        );
      });
    });

    context.emit("filteredData", finalComputedData);

    watch(finalComputedData, (newVal, oldVal) => {
      context.emit("filteredData", newVal);
    });

    return {
      searchedSymbol,
      riskReward,
      isValid,
      mySignals,
      volumeGreaterThenAvgVol,
      optionSectors,
      filterSymbol,
      optionData,
      selectedSector,
    };
  },
};
</script>
